"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "Will I feel any pain during my dental procedure?",
  answer: "Your comfort is our priority. Through our advanced sedation techniques and local anesthetics, we ensure that you are completely numb and relaxed. Most patients report feeling nothing more than light pressure, with no actual pain throughout the visit, allowing for a stress-free experience."
}, {
  question: "How safe is sedation for extractions or implants?",
  answer: "Dental sedation is extremely safe when administered by our trained professionals. At Smart Choice, we use hospital-grade monitoring equipment to track your oxygen levels and heart rate throughout the entire process, ensuring a secure and controlled environment while you receive your treatment."
}, {
  question: "What are the different levels of sedation available?",
  answer: "We provide a range of options including Nitrous Oxide (laughing gas) for light relaxation, Oral Conscious Sedation for moderate anxiety, and IV Sedation for those who prefer a deeper state of relaxation. We will customize the approach based on your specific procedure and comfort level."
}, {
  question: "Do I need someone to drive me home after the appointment?",
  answer: "If you receive Oral or IV sedation, you will need a responsible adult to drive you home and stay with you for a few hours as the effects wear off. However, Nitrous Oxide wears off almost immediately, typically allowing patients to drive themselves home safely after the procedure."
}, {
  question: "Will I remember anything about the treatment?",
  answer: "Depending on the level of sedation chosen, you may have little to no memory of the procedure. This is a significant benefit for patients with dental anxiety, as it makes a comprehensive appointment feel as though it lasted only a few minutes, reducing post-operative stress."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31848" id="sedation-faq" ref={ref} className={cn("dark bg-background text-foreground py-20 px-6 transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="mx-auto max-w-[800px]">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-4">
            Sedation & Comfort FAQ
          </h2>
          <p className="font-sans text-muted-foreground text-lg">
            Everything you need to know about our pain-free dental experience.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border last:border-b-0">
              <AccordionTrigger className="font-serif text-xl md:text-2xl font-medium text-foreground hover:text-primary transition-colors hover:no-underline py-6 text-left">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-base md:text-lg leading-relaxed text-muted-foreground pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}